import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import React from 'react';

const DrawerMenuItem = ({ children, handleClick, component }) => (
    <ListItem button component={component || 'div'} onClick={handleClick}>
        <ListItemText
            primary={children}
        />
    </ListItem>
);

export default DrawerMenuItem;



// WEBPACK FOOTER //
// ./src/components/header/DrawerMenuItem.js